'use client';

import { HeartPulseIcon } from '@jouzen/ecom-components/icons/HeartPulseIcon';
import { ShieldIcon } from '@jouzen/ecom-components/icons/ShieldIcon';
import { ZeroIcon } from '@jouzen/ecom-components/icons/ZeroIcon';
import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';
import RichText from '@/app/components/RichText';

const ProtectionPlanCoverage = () => {
  const t = useTranslations();

  return (
    <section className="pt-20">
      <LayoutGrid rowGap={32}>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <Typography Element="h2" className="flex justify-center">
            <Image
              src="extend/oura_extend_logo"
              format="png"
              localizedAlt="oura_and_extend_alt"
              width={350}
              height={66}
            />
          </Typography>
        </GridItem>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <Typography
            Element="h3"
            variant="unset"
            className="mb-14 text-center text-[26px] leading-[31px] md:text-[40px] md:leading-[48px]"
          >
            {t('extend_protection_header')}
          </Typography>
        </GridItem>
        <GridItem
          colEnd={{ sm: 'main' }}
          colStart={{ sm: 'main' }}
          className="flex flex-col gap-10 lg:flex-row lg:gap-16"
        >
          <div className="flex flex-1">
            <div>
              <ShieldIcon width={40} height={40} />
            </div>
            <div className="flex flex-col pl-4">
              <Typography
                Element="h4"
                variant="unset"
                className="pb-3.5 text-[22px] leading-[26px] font-normal md:text-[28px] md:leading-[33px]"
              >
                {t('extend_section_one_title')}
              </Typography>
              <Typography>{t('extend_section_one_description')}</Typography>
            </div>
          </div>
          <div className="flex flex-1">
            <div>
              <ZeroIcon width={40} height={40} />
            </div>
            <div className="flex flex-col pl-4">
              <Typography
                Element="h4"
                variant="unset"
                className="pb-3.5 text-[22px] leading-[26px] font-normal md:text-[28px] md:leading-[33px]"
              >
                {t('extend_section_two_title')}
              </Typography>
              <Typography>{t('extend_section_two_description')}</Typography>
            </div>
          </div>
          <div className="flex flex-1">
            <div>
              <HeartPulseIcon width={40} height={40} />
            </div>
            <div className="flex flex-col pl-4">
              <Typography
                Element="h4"
                variant="unset"
                className="pb-3.5 text-[22px] leading-[26px] font-normal md:text-[28px] md:leading-[33px]"
              >
                {t('extend_section_three_title')}
              </Typography>
              <Typography>
                <RichText messageKey="extend_section_three_description" />
              </Typography>
            </div>
          </div>
        </GridItem>
        <GridItem
          colEnd={{ sm: 'main' }}
          colStart={{ sm: 'main' }}
          className="border-b border-gray-400 pt-8 pb-20 lg:pt-14"
        >
          <Typography className="lg:text-center">
            {t('extend_section_header2')}
          </Typography>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default ProtectionPlanCoverage;
